import { Flex } from 'foundations-components/components/Flex';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { useGates } from '../../hooks/useGates';
import { useFilterConfig } from '../hooks/useFilterConfig';
import { LanguageFilter } from './reusableFilters/LanguageFilter';
import { SelectFilter } from './reusableFilters/SelectFilter';
import { ToggleFilter } from './reusableFilters/ToggleFilter';
import { useAppContext } from '../../context/AppContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function AppFilterControls() {
  const {
    APP_LANGUAGES,
    BUILT_BY_HUBSPOT,
    CATEGORY,
    CERTIFIED,
    HUBSPOT_FEATURES,
    PRICING_PLAN,
    SYNC_DIRECTION,
    TECHNOLOGY_PARTNER_TIER
  } = useFilterConfig();
  const gates = useGates();
  const appContext = useAppContext();
  const isPublic = appContext === 'public';
  const showTierFilter = gates.techPartnerTier || isPublic;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SelectFilter, {
      filter: PRICING_PLAN
    }), /*#__PURE__*/_jsx(SelectFilter, {
      filter: CATEGORY,
      multi: true
    }), /*#__PURE__*/_jsx(SelectFilter, {
      filter: HUBSPOT_FEATURES,
      multi: true
    }), /*#__PURE__*/_jsx(SelectFilter, {
      filter: BUILT_BY_HUBSPOT
    }), showTierFilter && /*#__PURE__*/_jsx(SelectFilter, {
      filter: TECHNOLOGY_PARTNER_TIER,
      multi: true
    }), CERTIFIED && (gates.searchFilterConfigRpc ? /*#__PURE__*/_jsx(SelectFilter, {
      filter: CERTIFIED
    }) : /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      marginBlockStart: "400",
      children: [/*#__PURE__*/_jsx(FormLabel, {
        htmlFor: CERTIFIED.field,
        children: CERTIFIED.label
      }), /*#__PURE__*/_jsx(ToggleFilter, {
        filter: CERTIFIED
      })]
    })), /*#__PURE__*/_jsx(SelectFilter, {
      filter: SYNC_DIRECTION
    }), /*#__PURE__*/_jsx(LanguageFilter, {
      filter: APP_LANGUAGES
    })]
  });
}